import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
    selector: "tree",
    templateUrl: "./tree.component.html",
    styleUrl: "./tree.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TreeComponent {
  public hideBranch = input<boolean>();
  
}
